import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const SEEN_KEY = 'ns-beta-note';

/**
 * Beta, said plainly, once: a note on the library's first visit (the A14 brand boards). Things
 * change weekly, some corners are rough, say what is wrong. Dismissed, it stays dismissed on
 * this device (localStorage); without storage it shows each time, which is harmless.
 */
export const BetaNote: React.FC<{ className?: string }> = ({ className = '' }) => {
  const [seen, setSeen] = useState<boolean>(() => {
    try { return localStorage.getItem(SEEN_KEY) === '1'; } catch { return false; }
  });
  if (seen) return null;
  const dismiss = () => {
    setSeen(true);
    try { localStorage.setItem(SEEN_KEY, '1'); } catch { /* no storage: shown again next time */ }
  };
  return (
    <div className={`ns-note ${className}`} data-tone="warn" role="note" data-beta-note>
      <p className="flex-1 text-sm leading-relaxed">
        <span className="font-bold">Welcome to the beta.</span> Things change weekly, and some corners are rough. Say what is wrong and it gets fixed fast.{' '}
        <Link to="/bugs" className="font-bold underline underline-offset-2" data-beta-note-link>Tell us</Link>
      </p>
      <button type="button" onClick={dismiss} className="ns-icon-btn ns-icon-btn-xs shrink-0" aria-label="Dismiss"><X /></button>
    </div>
  );
};

export default BetaNote;
